// extracted by css-extract-rspack-plugin
export default {"icon":"SegmentFilterEditor__icon___rOTxO"};